import React from 'react';
import styles from './css/PowerGrid.module.css';

interface CurrentPowerGridProps {
    data: { [key: string]: any };
}

interface GridItemProps {
    value: number;
    unit: string;
    description: string;
}

const formatValue = (value: number) => {
    if (value >= 1000000) {
        return `${(value / 1000000).toFixed(1)}M`;
    }
    if (value >= 1000) {
        return `${(value / 1000).toFixed(1)}K`;
    }
    if(value % 1 !== 0) {
        return value.toFixed(2);
    }
    return value;
}

const GridItem = ({ value, unit, description }: GridItemProps) => {
    return (
        <div className={styles.gridItem}>
            <div className={styles.headingContainer}>
                <h1 className={styles.unit}>{unit}</h1>
                <h1 className={styles.heading}>{formatValue(value || 0)}</h1>
            </div>
            <p className={styles.description}>{description}</p>
        </div>
    );
};

export const CurrentPowerGrid = ({ data }: CurrentPowerGridProps) => {
    const gridItems = [
        {
            value: data.existing_electrical_capacity_residential || 0,
            unit: "KW",
            description: "מגורים"
        },
        {
            value: data.total_existing_electrical_capacity || 0,
            unit: "MW",
            description: "סה\"כ שימושים אחרים (בלי מגורים)"
        }
    ];

    return (
        <div className={styles.gridContainer}>
            {gridItems.map((item, index) => (
                <GridItem key={index} {...item} />
            ))}
        </div>
    );
}; 